/**
 * The demo data, in English. GENERATED by scripts/i18n/build.mjs — to change
 * any of it, edit scripts/i18n/data.en.json and re-run the script.
 *
 * RawamDemo.sql is an Arabic dataset, so an English screen would otherwise show
 * English chrome over Arabic rows. This maps the vocabulary the data uses as
 * LABELS — statuses, roles, departments, activity names, risk levels, badges,
 * difficulty levels, topic and program and chapter names, policy and survey
 * titles, incident types, notification subjects — to English.
 *
 * Three sources, in order of authority:
 *
 *   1. The database itself. Every topic row in dbo.Categories carries a
 *      `nameEn` beside its `name`, and every company an `englishName`.
 *   2. The legacy Locale/*.resx pairs, for anything the MVC app already had a
 *      word for — every activity in the system log, every role, every status.
 *   3. scripts/i18n/data.en.json, in the same register, for the rest.
 *
 * What is deliberately NOT translated:
 *
 *   - People's names. They are real records; a name is not a label.
 *   - Phishing lure subjects and their bodies. A campaign run against
 *     Arabic-speaking staff sends Arabic mail — the lure is the artefact under
 *     test, not product copy, and translating it would misrepresent what the
 *     campaign actually sent.
 *   - Exam questions, answer options and article bodies. That is the licensed
 *     content library, which exists in Arabic in the source database. An
 *     English admin looking at an Arabic course sees exactly what the learner
 *     will see, which is the truth of the installation.
 *
 * 405 entries.
 */

const DICTIONARY = {
  'آلية التعامل مع حوادث تسرب البيانات.': 'Responding to a data leak.',
  'ابراهيم حمد الشمري': 'Ibrahim Hamad Al-Shammari',
  'اجتياز الاختبارات': 'Pass Tests',
  'اجتياز القياس': 'Pass Measurement',
  'إجراءات إتلاف الوثائق السرية والمقيدة.': 'How confidential and restricted documents are destroyed.',
  'اختبار': 'Test',
  'اختبارt': 'Test t',
  'اختراق': 'Intrusion',
  'أخطار الهجمات على إنترنت الأشياء.': 'Dangers of IoT attacks.',
  'ادارة': 'Department',
  'ادارة الإعلام': 'Media Department',
  'إدخال البيانات في موقع اصطياد': 'Entering Data On Phishing Site',
  'أرامكو السعودية': 'Saudi Aramco',
  'أرب': 'ARB',
  'إرشادات تأمين حساباتك في الأنظمة السحابية.': 'Securing your cloud accounts.',
  'إزالة صلاحيات': 'Remove Privilege',
  'أساسيات الأمن السيبراني': 'Cybersecurity basics',
  'أساسيات الأمن السيبراني - ممتاز': 'Cyber Security Fundamentals — Excellent',
  'أساسيات الأمن السيبراني.': 'Cyber security fundamentals.',
  'أساليب التصيد الإلكتروني.': 'Phishing techniques.',
  'أساليب سرقة كلمات المرور.': 'How passwords are stolen.',
  'استبيان إلزامي | Mandatory Survey': 'Mandatory Survey',
  'استبيان جديد متاح الآن | New Survey Available': 'New Survey Available',
  'استخدام الاتصال المشفر عند إتمام إجراءات الحجز والمعاملات المالية.': 'Using an encrypted connection for bookings and payments.',
  'استخدام شبكة خاصة افتراضية.': 'Using a VPN.',
  'اصطياد الكتروني': 'Phishing',
  'إضافة استبيان': 'Add Survey',
  'إضافة برنامج تدريبي جديد': 'Add New Learning Program',
  'إضافة بلاغ أمني جديد': 'Add New Security Report',
  'إضافة دعوة جديدة': 'Add New Invitation',
  'إضافة دورة': 'Add a Course',
  'إضافة دورة تدريبية جديدة': 'Add new Course',
  'إضافة سياسة جديد': 'Add New Policy',
  'إضافة صلاحيات': 'Add Privilege',
  'إضافة مجموعة': 'Add Group',
  'إعادة تعيين كلمة المرور': 'Reset Password',
  'إعادة ضبط كلمة المرور': 'Reset Password',
  'إعدادات النظام': 'Application Settings',
  'إغلاق البلاغات': 'Close Security Reports',
  'افتراضي': 'Default',
  'أفضل الممارسات على مستوى جهة العمل.': 'Best practice at organization level.',
  'أفضل الممارسات لحماية أجهزة إنترنت الأشياء.': 'Best practice for protecting IoT devices.',
  'أفضل الممارسات للتخلص الآمن من البيانات.': 'Best practice for safe data disposal.',
  'أفضل ممارسات الأمن السيبراني لفرق تقنية المعلومات والتحول الرقمي': 'Cybersecurity Best Practices for IT and Digital Transformation Teams',
  'أفضل ممارسات الأمن السيبراني لفرق تقنية المعلومات والتحول الرقمي.': 'Cyber security best practice for IT and digital transformation teams.',
  'أكثر أجهزة إنترنت  الأشياء تعرضا للهجمات.': 'The most attacked IoT devices.',
  'الإبلاغ عن اصطياد إلكتروني': 'Report Phishing',
  'الإبلاغ عن الجرائم المعلوماتية.': 'Reporting cybercrime.',
  'الاتصال بشبكات لاسلكية آمنة.': 'Connecting to secure wireless networks.',
  'الإتلاف الآمن للبيانات': 'Secure Destruction of Data',
  'الإجراءات المتقدمة التي تساعد على تأمين تصفح الإنترنت.': 'Advanced steps for safer browsing.',
  'الاحتفاظ بنسخ احتياطية من البيانات.': 'Keeping backups of your data.',
  'الاحتفاظ بنسخ رقمية من الوثائق.': 'Keeping digital copies of your documents.',
  'الاختراق': 'Hacking',
  'الإدارات': 'Departments',
  'الأساسيات في الأمن السيبراني': 'Cyber Security Basics',
  'الاستبيانات - استبيان إلزامي': 'Surveys - Required Survey',
  'الاستبيانات - استبيان جديد': 'Surveys - New Survey',
  'الاستخدام الآمن للطابعات والماسحات الضوئية وأجهزة النسخ.': 'Safe use of printers, scanners and copiers.',
  'الأسطورة': 'Legend',
  'الإعدادات الأمنية للأجهزة المحمولة.': 'Security settings for mobile devices.',
  'الإعدادات المتقدمة': 'Advanced Settings',
  'الأمن السيبراني': 'cyber security',
  'الأمن الصناعي': 'Industrial Systems Security',
  'الأمن المادي': 'Phyiscal Security',
  'البرامج الخبيثة': 'Malware',
  'البنك الأهلي السعودي': 'Saudi National Bank',
  'البيانات': 'Data',
  'البيانات الشخصية.': 'Personal data.',
  'البيانات العامة.': 'Public data.',
  'التأكد من مصادر وتفاصيل التطبيقات.': 'Checking app sources and details.',
  'التجسس.': 'Spying.',
  'التحقق من الشهادات': 'Certificate Validation Group',
  'التحليل الجنائي الرقمي': 'Digital Forensics',
  'التسجيل': 'Registration',
  'التشفير': 'Cryptography',
  'التصيد الإلكتروني': 'Phishing',
  'التصيد الالكتروني': 'Phishing',
  'التصيّد الإلكتروني الموجه.': 'Spear phishing.',
  'التعامل الآمن مع البيانات السرية خارج مقر العمل.': 'Handling confidential data safely off site.',
  'التعامل الآمن مع الوثائق والمستندات': 'Secure Handling of Documents',
  'التعامل الآمن مع خدمات تصفح الإنترنت': 'Safe Browsing',
  'التقارير الأمنية': 'Security Reports',
  'التلعيب': 'Gamification',
  'التهديدات والأخطار التي تستهدف الأجهزة (أرقام ووقائع).': 'Threats to devices — the numbers.',
  'التهديدات والأخطار التي تستهدف الشبكات اللاسلكية.': 'Threats to wireless networks.',
  'الجرائم المعلوماتية': 'Cyber Crimes',
  'الحذر من الرسائل البريدية والنصية.': 'Being wary of email and text messages.',
  'الحفاظ على إعدادات حماية الأجهزة.': 'Keeping device protection settings in place.',
  'الحماية الرقمية أثناء وبعد السفر.': 'Digital protection during and after travel.',
  'الحماية المادية للأجهزة المحمولة.': 'Physical protection of mobile devices.',
  'الحماية من الفيروسات في الروابط والمحادثات.': 'Protecting against viruses in links and chats.',
  'الحماية من خطر التطبيقات.': 'Protecting against risky apps.',
  'الحماية من خطر نشر معلوماتك وخصوصياتك.': 'Protecting your information and privacy.',
  'الحوادث السيبرانية - بلاغ جديد': 'Security Reports - New Report',
  'الحوادث السيبرانية - تعليق جديد': 'Security Reports - New Comment',
  'الحوادث السيبرانية - تغير الحالة': 'Security Reports - State Change',
  'الحوسبة السحابية.': 'Cloud computing.',
  'الخبير': 'Expert',
  'الختام.': 'Conclusion.',
  'الرؤية الموثوقة': 'Trusted Vision',
  'السياسات': 'Policies',
  'الشرقية': 'Eastern',
  'الشهادة الإفتراضية': 'Default Certificate',
  'الضوابط الأساسية للأمن السيبراني': 'Essential Cybersecurity Controls',
  'الطرق المثلى لتصفح الإنترنت بأمان.': 'Browsing the internet safely.',
  'الطلاب': 'Students',
  'الغربية': 'Western',
  'القائد': 'Leader',
  'القسم النسائي': 'Women\'s Section',
  'القياسات': 'Assessments',
  'القياسات - قياس إلزامي': 'Mandatory Assessment',
  'القياسات - قياس جديد': 'New Assessment',
  'المبتدئ': 'Beginner',
  'المتعلم النشط': 'Active Learner',
  'المتميز': 'Outstanding',
  'المثابر': 'Persistent',
  'المحترف': 'Professional',
  'المحتوى التعليمي': 'Learning Content',
  'المخاطر الأمنية للتعاملات الإلكترونية.': 'Security risks of electronic transactions.',
  'المخاطر الفيزيائية.': 'Physical risks.',
  'المخترقون أو الهاكرز.': 'Intruders and hackers.',
  'المدراء': 'Administrators',
  'المساهم': 'Contributor',
  'المستخدمين': 'Users',
  'المستكشف': 'Explorer',
  'المشاركة في الاستبيانات': 'Participate In Surveys',
  'المعايير المعتمدة.': 'The adopted standards.',
  'الممارسات المُثلى للحفاظ على أمان وخصوصية البيانات (1).': 'Best practice for data security and privacy (1).',
  'الممارسات المُثلى للحفاظ على أمان وخصوصية البيانات (2).': 'Best practice for data security and privacy (2).',
  'الموافقة على السياسات': 'Approve Policies',
  'النتائج المتوقعة.': 'Expected outcomes.',
  'النسخ الاحتياطي.': 'Backups.',
  'النشرات التوعوية': 'Awareness Content',
  'الهجمات السيبرانية على الإنترنت.': 'Cyber attacks on the internet.',
  'الهندسة الاجتماعية': 'Social Engineering',
  'الهندسة الإجتماعية بإستخدام الأدوات التقنية.': 'Social engineering using technical tools.',
  'الهندسة الإجتماعية بدون إستخدام الأدوات التقنية.': 'Social engineering without technical tools.',
  'الهندسة الإجتماعية.': 'Social engineering.',
  'الهيئة السعودية للبيانات والذكاء الاصطناعي': 'SDAIA',
  'الهيئة الملكية للجبيل وينبع': 'Royal Commission for Jubail and Yanbu',
  'الهيئة الوطنية للأمن السيبراني': 'National Cybersecurity Authority',
  'الوثائق الإلكترونية.': 'Electronic documents.',
  'الوثائق والسجلات المالية.': 'Financial documents and records.',
  'الوسطى': 'Central',
  'أمثلة لاختراق أنظمة صناعية.': 'Examples of industrial system breaches.',
  'أمن الاجتماع عن بعد.': 'Securing remote meetings.',
  'أمن الأجهزة': 'Device Security',
  'أمن الأجهزة المحمولة': 'Mobile Security',
  'أمن الأنظمة السحابية': 'Cloud Systems Security',
  'أمن الانظمة السحابية': 'Cloud Systems Security',
  'أمن الأنظمة السحابية gfd': 'Cloud computing security',
  'أمن البريد الإلكتروني': 'Email Security',
  'امن البريد الالكتروني': 'Email Security',
  'أمن البيانات السحابية': 'Cloud Data Security',
  'أمن البيانات وحمايتها': 'Data Security and Protection',
  'أمن التعاملات البنكية': 'Online Transactions Security',
  'أمن الشبكات الاجتماعية': 'Social Networks Security',
  'امن الشبكات الاجتماعية': 'Social Network Security',
  'أمن الشبكات اللاسلكية': 'Wireless Network Security',
  'أمن العمل عن بعد': 'Remote Work Security',
  'أمن المسافر': 'Traveler Security',
  'أمن المواقع الالكترونية والانترنت': 'Web and Internet Security',
  'أمن إنترنت الأشياء': 'IoT Security',
  'أمن كلمات المرور': 'Passwords',
  'إنشاء حساب': 'Create Account',
  'إنشاء كلمة مرور معقدة.': 'Creating a strong password.',
  'إنشاء مستخدم': 'User Creation',
  'انهاء الاختبار': 'End Exam',
  'أنواع الإختراق.': 'Types of intrusion.',
  'أنواع البرامج الخبيثة 2.': 'Types of malware 2.',
  'أنواع البرامج الخبيثة.': 'Types of malware.',
  'أنواع التشفير.': 'Types of encryption.',
  'أنواع الجرائم المعلوماتية.': 'Types of cybercrime.',
  'أنوع مخاطر تسرب البيانات والوصول غير المصرح به إليها.': 'Types of data leakage and unauthorised access risk.',
  'اهتمام المملكة العربية السعودية بالوثائق (1).': 'How Saudi Arabia treats records (1).',
  'اهتمام المملكة العربية السعودية بالوثائق (2).': 'How Saudi Arabia treats records (2).',
  'أهداف التشفير.': 'Goals of encryption.',
  'أهداف الجرائم المعلوماتية.': 'Aims of cybercrime.',
  'أهداف المؤشر.': 'Goals of the index.',
  'أهم النصائح للحماية من خُدع الحجز عبر الإنترنت.': 'Avoiding online booking scams.',
  'أهمية تأمين الأنظمة الصناعية.': 'Why industrial systems must be secured.',
  'أهمية تأمين إنترنت الأشياء.': 'Why IoT must be secured.',
  'أهمية حماية البيانات الشخصية.': 'Why personal data must be protected.',
  'أولا إتلاف البيانات السرية.': 'First: destroying confidential data.',
  'بإنتظار التفعيل': 'Waiting activation',
  'بدء الاختبار': 'Start Exam',
  'بداية برنامج تدريبي': 'Training Program Start',
  'بداية دورة تدريبية': 'Course Start',
  'برنامج التوعية بالأمن السيبراني': 'Cyber Security Awareness Program',
  'برنامج التوعية بالأمن السيبراني الشامل': 'Comprehensive Cyber Security Awareness Program',
  'برنامج التوعية سايت': 'SITE Awareness Program',
  'برنامج خبيث': 'Malware',
  'بلاغ أمني جديد | New Security Report': 'New Security Report',
  'بلسم': 'Balsam',
  'بلقيس': 'Bilqis',
  'تأثير عكسي': 'Reversed effect',
  'تأخر الموافقة على سياسة': 'Policy Agreement Requirement',
  'تأمين': 'Insurance',
  'تأمين البطاقات البنكية أثناء السفر.': 'Protecting bank cards while travelling.',
  'تجربة 2': 'Trial 2',
  'تجربة إصطياد 5': 'Phishing trial 5',
  'تجربة الاصطياد': 'Phishing trial',
  'تجربة الاصطياد ٢': 'Phishing trial 2',
  'تجربة قالب امانة الرياض': 'Riyadh Municipality template trial',
  'تجربه': 'Trial',
  'تحديث استبيان': 'Update Survey',
  'تحديث البرامج والتطبيقات.': 'Updating software and apps.',
  'تحديث التصنيف': 'Update Category',
  'تحديث المجموعة': 'Update Group',
  'تحديث بيانات برنامج تدريبي': 'Update program',
  'تحديث بيانات بلاغ أمني': 'Update Security Report',
  'تحديث بيانات دورة تدريبية': 'Update Course',
  'تحديث بيانات سياسة': 'Update Policy',
  'تحديث بيانات مقال توعوي': 'Update Awareness Content',
  'تحديث صلاحية الوصول لمنصة VPN': 'VPN access renewal',
  'تحديث معلومات الحساب': 'Update Profile Information',
  'تحميل السياسات': 'Download Policies',
  'تخمين كلمات المرور.': 'Password guessing.',
  'تدريب 2025': 'Training 2025',
  'تذكير: بدء برنامج تدريبي قادم | Reminder: Upcoming Training Program Starts Soon': 'Reminder: Upcoming Training Program Starts Soon',
  'تذكير: بدء دورة تدريبية قادمة | Reminder: Upcoming Training Starts Soon': 'Reminder: Upcoming Training Starts Soon',
  'ترفيه': 'Entertainment',
  'تست': 'Test',
  'تست 5': 'Test 5',
  'تسجيل الخروج من المواقع.': 'Signing out of websites.',
  'تسجيل الدخول': 'Login',
  'تسجيل دخول بدون كلمة مرور عبر رابط': 'Passwordless login link',
  'تصفير والبدء من جديد في يوم المعرض': 'Reset and start over on exhibition day',
  'تطبيقات التشفير.': 'Applications of encryption.',
  'تعريف الإختراق.': 'What intrusion is.',
  'تعريف البيانات الشخصية.': 'What personal data is.',
  'تعريف أمان إنترنت الأشياء.': 'What IoT security is.',
  'تعريف إنترنت الأشياء.': 'What the Internet of Things is.',
  'تعليق جديد على بلاغ أمني | New Comment on Security Report': 'New Comment on Security Report',
  'تغيير إعدادات النظام': 'Change System Settings',
  'تغيير حالة بلاغ أمني | Security Report Status Update': 'Security Report Status Update',
  'تفعيل الحساب': 'Activations',
  'تفعيل خاصية التتبع.': 'Turning on device tracking.',
  'تقييم وعي الموظفين بالأمن السيبراني': 'Employee Cyber Security Awareness Assessment',
  'تم إنشاء الحساب بنجاح | Account Created Successfuly': 'Account Created Successfully',
  'تنمية': 'Tanmiah',
  'تهانينا! لقد تحصلت على 0 نقاط جديدة': 'Congratulations! You earned 0 new points',
  'تهانينا! لقد حصلت على 0 نقاط جديدة': 'Congratulations! You earned 0 new points',
  'تهانينا! لقد حصلت على 10 نقاط جديدة': 'Congratulations! You earned 10 new points',
  'تهانينا! لقد حصلت على 2 نقاط جديدة': 'Congratulations! You earned 2 new points',
  'تهانينا! لقد حصلت على 5 نقاط جديدة': 'Congratulations! You earned 5 new points',
  'تهانينا! لقد حصلت على 50 نقاط جديدة': 'Congratulations! You earned 50 new points',
  'توجيهات التعامل الآمن للبيانات أثناء الاجتماعات الافتراضية (عن بعد).': 'Handling data safely in virtual meetings.',
  'ثانياً إتلاف البيانات المقيدة.': 'Second: destroying restricted data.',
  'ثصقصثقصثق': '(keyboard test)',
  'جامعة الأميرة نورة': 'Princess Nourah University',
  'جامعة الملك سعود': 'King Saud University',
  'جوائز ماليه': 'Cash prizes',
  'حالات استخدام المعلومات الشخصية.': 'Where personal information is used.',
  'حذف استبيان': 'Delete Survey',
  'حذف برنامج تدريبي': 'Delete Learning Program',
  'حذف تصنيف': 'Delete Category',
  'حذف دورة تدريبية': 'Delete Course',
  'حفظ البيانات و النسخ الاحتياطي': 'Data Storage and Backup',
  'حفظ البيانات والنسخ الاحتياطي': 'Data Storage and Backup',
  'حقوق صاحب البيانات.': 'Rights of the data subject.',
  'حماية الشبكات اللاسلكية الخارجية والمنزلية وأجهزة التوجيه (الراوتر).': 'Protecting home and external wireless networks and routers.',
  'حماية شبكة الاتصال اللاسلكي العامة..': 'Protecting public wireless networks.',
  'حماية كلمة المرور من السرقة.': 'Protecting your password from theft.',
  'حماية وادارة البيانات الشخصية': 'Personal Data Protection and Management',
  'حوكمة الأمن السيبراني وتحقيق القيمة الإستراتيجية': 'Cybersecurity Governance and Strategic Value Creation',
  'خاتمة.': 'Conclusion.',
  'خدمات الهيئة ومهامها الرئيسية.': 'The Authority\'s services and main duties.',
  'خسائر سرقة البيانات.': 'The cost of data theft.',
  'خصومات': 'Discounts',
  'خطر سرقة البيانات.': 'The risk of data theft.',
  'خطر متوسط': 'Medium risk',
  'خطر مرتفع': 'High risk',
  'خطر منخفض': 'Low risk',
  'داخلي': 'InApp',
  'دعوة': 'Invitation',
  'دعوة للتسجيل | Invitation to Register\\r\\n': 'Invitation to Register',
  'دوافع سرقة الهوية.': 'Motives behind identity theft.',
  'سجلات النظام': 'System Logs',
  'سرقة المعلومات الشخصية.': 'Theft of personal information.',
  'سرقة الهوية': 'Identity Theft',
  'سفر': 'Travel',
  'سهل': 'Easy',
  'سياسة المكتب النظيف': 'Clean desk policy',
  'سياسة أمن كلمات المرور': 'Password Security Policy',
  'سياسة تصنيف البيانات ومستويات تصنيفها.': 'Data classification policy and its levels.',
  'سياسة جديدة': 'New Policy',
  'شركة الاتصالات السعودية': 'stc',
  'شركة معادن': 'Maaden',
  'شسيش': '(keyboard test)',
  'شهادة': 'Certificate',
  'صديق': 'Siddiq',
  'صديق - إصطياد': 'Siddiq — phishing',
  'صعب': 'Hard',
  'صفحة اتصل بنا - رسالة جديدة': 'Contact Us New Message',
  'صياد': 'Phishing',
  'ضغط الرابط في بريد اصطياد': 'Clicking On The Link In Phishing Email',
  'ضوابط تُسهم في تعزيز الأمن السيبراني (1).': 'Controls that strengthen cyber security (1).',
  'ضوابط تُسهم في تعزيز الأمن السيبراني (2).': 'Controls that strengthen cyber security (2).',
  'ضوابط حماية وإدارة البيانات الشخصية بكفاءة وأمان': 'Controls to protect and manage personal data efficiently and safely',
  'طرق الحماية من الإختراق.': 'Protecting against intrusion.',
  'طرق الحماية من المخاطر.': 'Protecting against the risks.',
  'طرق الوقاية من البرامج الخبيثة.': 'Preventing malware.',
  'طرق الوقاية من سرقة الهوية.': 'Preventing identity theft.',
  'طُرق تمييز البريد التصيدي.': 'Spotting a phishing email.',
  'طرق في الحماية من الهندسة الإجتماعية.': 'Protecting against social engineering.',
  'طرق في حماية التعاملات البنكية.': 'Protecting banking transactions.',
  'طرق في حماية منطقة العمل.': 'Protecting the workspace.',
  'طلب إعادة تعيين كلمة المرور': 'Reset Password Request',
  'غيدا': 'Ghaida',
  'فرق التحول الرقمي.': 'Digital transformation teams.',
  'في': 'Fi',
  'في انتظار تاكيد الاستقاله': 'Awaiting resignation approval',
  'في انتظار تفعيل الحساب': 'Awaiting activation',
  'قراءة بريد إلكتروني اصطياد': 'Reading Phishing Email',
  'قياس': 'Assessment',
  'قياس 3': 'Assessment 3',
  'قياس مستوى وعي الموظفين': 'Employee Awareness Level Assessment',
  'كيف تحدث هذه الهجمات؟.': 'How these attacks happen.',
  'كيف تعمل هجمات الفدية': 'How ransomware attacks work',
  'كيف يتم الإختراق؟.': 'How an intrusion happens.',
  'لال': 'Lal',
  'للل': '???',
  'لماذا نحتاج إلى حماية أجهزتنا؟.': 'Why our devices need protecting.',
  'لوحة المستخدم': 'User Panel',
  'ليب': 'LEAP',
  'ما الشبكات اللاسلكية ولماذا نحتاج إلى حمايتها؟.': 'What wireless networks are and why they need protecting.',
  'مؤشر الأمن السيبراني الوطني.': 'The National Cybersecurity Index.',
  'مبتدئ': 'Beginner',
  'متقدم': 'Advanced',
  'متوسط': 'Medium',
  'مجموعة الاستبيانات': 'Surveys Group',
  'مجموعة خاصة': 'Custom group',
  'مجموعة صفحة الإحصائيات': 'Statistics Page Group',
  'محظور': 'Blocked',
  'محللو البيانات ومهندسو البيانات.': 'Data analysts and data engineers.',
  'مخاطر الأمن السيبراني': 'Cyber Security Risks',
  'مخاطر الأمن السيبراني المتعلقة باستخدام وسائط التخزين الخارجية.': 'Risks of external storage media.',
  'مخاطر الرسائل غير المرغوبة.': 'Risks of spam.',
  'مخاطر الروابط والمرفقات عبر البريد.': 'Risks of email links and attachments.',
  'مخاطر الشبكات الإجتماعية.': 'Risks of social networks.',
  'مخاطر بسبب أخطاء المستخدم.': 'Risks from user error.',
  'مخاطر عدم إمكانية حذف معلوماتك.': 'The risk that your information cannot be deleted.',
  'مخاطر مشاركة المستندات والمعلومات من خلال قنوات غير آمنة.': 'Risks of sharing documents over insecure channels.',
  'مخاطر نشر معلوماتك الخاصة.': 'Risks of posting your private information.',
  'مخالفة لسياسة': 'Policy violation',
  'مخاوف التشفير.': 'Concerns around encryption.',
  'مرفق عربي': 'Arabic attachment',
  'مركز التميز لأمن المعلومات': 'Center of Excellence in Information Assurance',
  'مركز التميز لأمن المعلومات فقط': 'Center of Excellence in Information Assurance only',
  'مسؤولو قواعد البيانات (Dbas).': 'Database administrators (DBAs).',
  'مسؤولية الموظفين وجهات العمل التي تتعامل مع البيانات.': 'Responsibilities of staff and employers handling data.',
  'مسؤولية جهة العمل والمنسوبين.': 'Responsibility of the employer and its staff.',
  'مستخدم تجريبي': 'Demo user',
  'مستقيل': 'Resigned',
  'مشاركه': 'Participation',
  'مشاهدة النشرات': 'Watch Awareness',
  'مشاهدة مقاطع الفيديو التعليمية': 'Watch Educational Videos',
  'مشروع برنامج تركيب منصة "روام" وزارة الإعلام': 'Rawam platform rollout — Ministry of Media',
  'مصرف الراجحي': 'Al Rajhi Bank',
  'مصطلحات مهمة في التشفير.': 'Key encryption terms.',
  'مصممي الأنظمة.': 'System designers.',
  'معرض الهيئة': 'ZAKAT',
  'معطل': 'Disabled',
  'مفعل': 'Enabled',
  'مفهوم البرامج الخبيثة.': 'What malware is.',
  'مقدمة تعريفية 2.': 'Introduction 2.',
  'مقدمة تعريفية.': 'Introduction.',
  'مقدمة في الحوسبة السحابية': 'Introduction to Cloud Computing',
  'مقدمة.': 'Introduction.',
  'ممارسات خاطئة تؤدي إلى الإصابة بالبرامج الخبيثة.': 'Habits that lead to malware infection.',
  'مميز': 'Featured',
  'منتهي الصلاحية': 'Expired',
  'منهجية التقييم.': 'Assessment methodology.',
  'مواضيع متقدمة': 'Advanced Topics',
  'موظفين هيئة الزكاة': 'Zakat Authority staff',
  'موقوف': 'Suspended',
  'نجربة 1': '????? 2',
  'نشرة تواصل ليوم الثلاثاء 18 صفر 1447 هـ الموافق 12 أغسطس 2025م': 'Communications bulletin — Tuesday 12 August 2025',
  'نشرة توعية جديدة': 'New Awaremess Post',
  'نشرة توعية جديدة | New Awareness Article Published': 'New Awareness Article Published',
  'نشط': 'Active',
  'نصائح عند استخدام خدمات التخزين السحابي.': 'Tips for using cloud storage services.',
  'نصائح في أمن الشبكات الإجتماعية.': 'Social network security tips.',
  'نصائح للنسخ الإحتياطي.': 'Backup tips.',
  'نطاق الأمن السيبراني.': 'The scope of cyber security.',
  'نطاق المؤشر ومحاوره الرئيسية.': 'Scope and main pillars of the index.',
  'نظام سويفت': 'SWIFT',
  'نظام مكافحة الجرائم المعلوماتية.': 'The Anti-Cyber Crime Law.',
  'نمو التعاملات الإلكترونية في المملكة.': 'Growth of electronic transactions in the Kingdom.',
  'نهاية برنامج تدريبي': 'Training Program End',
  'نهاية دورة تدريبية': 'Course End',
  'هجوم الفدية: كيف يؤثر على عملك': 'Ransomware: how it affects your work',
  'هل شبكات إنترنت الأشياء آمنة؟.': 'Are IoT networks safe?',
  'هيئة الاتصالات والفضاء والتقنية': 'CST',
  'هيئة الزكاة والدخل': 'Zakat and Income Authority',
  'وثائق إعداد الأنظمة والاستشارات القانونية.': 'System configuration and legal advice documents.',
  'وزارة الصحة': 'Ministry of Health',
  'وسائل التصيد الإلكتروني وطرق الوقاية منه.': 'Phishing channels and how to avoid them.',
  'وسائل تأمين الموارد المادية.': 'Securing physical assets.',
  'يوم المعرض': 'Exhibition day',
  'New Message From User | رسالة جديدة من مستخدم': 'New Message From User',
  'New Policy| سياسة جديدة': 'New Policy',
  'RE: تصاميم روام | أمانة الرياض': 'RE: Rawam designs | Riyadh Municipality',
}

/**
 * Titles the data builds by gluing a course or program name onto a stock
 * phrase. Listing every combination would be dozens of near-identical rows;
 * translating the stem and looking the tail up covers all of them and keeps
 * working when the data gains a course.
 */
const PREFIXES = [
  ['استطلاع رضا المتدربين عن دورة بعنوان ', 'Trainee satisfaction survey — course: '],
  ['استطلاع رضا المتدربين عن برنامج بعنوان  ', 'Trainee satisfaction survey — program: '],
  ['إستبيان تقييم الدورة التدريبية ', 'Course evaluation survey — '],
  ['استبيان تقييم الدورة التدريبية ', 'Course evaluation survey — '],
  ['إستبيان تقييم البرنامج التدريبي ', 'Program evaluation survey — '],
  ['استبيان تقييم البرنامج التدريبي ', 'Program evaluation survey — '],
]

/** The English for one Arabic string, or null when it is content, not a label. */
export function translate(value) {
  const hit = DICTIONARY[value]
  if (hit) return hit
  for (const [ar, en] of PREFIXES) {
    if (!value.startsWith(ar)) continue
    const tail = value.slice(ar.length).trim()
    return en + (DICTIONARY[tail] ?? tail)
  }
  return null
}

export default DICTIONARY
